(() => {
  if (window.potoCommentTranslations) return;
  window.potoCommentTranslations = true;
  const supported = new Set(['ja','ko','fr','de','es','ar','zh-tw']);
  const text = html => new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
  const normalized = value => value.replace(/\s+/g, ' ').trim();
  async function load(root = document) {
    const nodes = [...root.querySelectorAll('[data-poto-comment-id]')].filter(node => !node.dataset.potoLoaded && supported.has(node.dataset.potoLocale.toLowerCase()));
    for (const node of nodes) node.dataset.potoLoaded = 'true';
    for (let start=0;start<nodes.length;start+=10) {
      const batch=nodes.slice(start,start+10);
      const url=new URL('/apps/poto-comments',location.origin);
      url.searchParams.set('locale',batch[0].dataset.potoLocale);
      url.searchParams.set('ids',batch.map(node=>node.dataset.potoCommentId).join(','));
      try {
        const response=await fetch(url,{signal:AbortSignal.timeout(15000),credentials:'same-origin'});
        if(!response.ok)continue;
        const payload=await response.json();
        if(!Array.isArray(payload.comments))continue;
        for(const node of batch){
          const cached=payload.comments.find(comment=>comment.id===node.dataset.potoCommentId);
          if(!cached || typeof cached.source!=='string' || typeof cached.value!=='string')continue;
          const original=node.querySelector('[data-poto-comment-original]');
          if(normalized(text(cached.source))!==normalized(original.textContent))continue;
          const translated=node.querySelector('[data-poto-comment-translated]');
          // Only text is inserted: model output can never execute HTML or script.
          translated.textContent=text(cached.value);
          translated.style.whiteSpace='pre-wrap';
          translated.hidden=false;original.hidden=true;
          const button=node.querySelector('[data-poto-comment-toggle]');
          const label=node.querySelector('[data-poto-comment-label]');
          label.hidden=false;button.hidden=false;
          button.textContent=node.dataset.originalLabel;
          button.addEventListener('click',()=>{
            original.hidden=!original.hidden;translated.hidden=!original.hidden;
            label.hidden=!original.hidden;
            button.textContent=original.hidden?node.dataset.originalLabel:node.dataset.translatedLabel;
            button.setAttribute('aria-pressed',String(!original.hidden));
          });
        }
      } catch { /* Keep original comments when cache or proxy is unavailable. */ }
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>void load());else void load();
  document.addEventListener('shopify:section:load',event=>void load(event.target));
})();
